import axios, { RawAxiosRequestConfig, AxiosResponse, CancelTokenStatic } from "axios";
import { apiCallHeader } from "../types/api/header.types";
import { appConfig } from "../config/apiConfig";
import { store } from "../../redux";

class abstractApiCaller {
  protected controller: AbortController;

  constructor() {
    this.controller = new AbortController();
  }


  public abortRequest(): boolean {
    this.controller.abort();
    return true;
  }


  protected async query<T>(
    apiCall: string,
    body: object = {},
    accessToken: string = '',
    accessEmail: string = '',
    callbackProgress?: (percentage: number) => void
  ) {

    const objHeader = this.getRequestHeader();

    if (accessToken !== '') {
      objHeader.Authorization = accessToken;
      objHeader.UserEmail = accessEmail;
    }

    const axiosClient = axios.create();
    axiosClient.defaults.baseURL = appConfig.api.url;
    axiosClient.defaults.timeout = 19000;
    axiosClient.defaults.withCredentials = true;

    axios.interceptors.request.use(
      (request) => {
        request.headers.set('Access-Control-Allow-Origin', '*');
        request.headers.set('Access-Control-Allow-Methods', 'GET, POST, OPTIONS');
        request.headers.set('Access-Control-Allow-Headers', '*');
        request.headers.set('Content-Type', 'application/json');
        request.headers.set('Accept', 'application/json');
        return request;
      },
      (error) => {
        return error;
      },
      { synchronous: true }
    );

    axios.interceptors.response.use(
      (response) => {
        //Dispatch any action on success
        return response;
      },
      function (error) {
        if (error.response.status === 401) {
          //Add Logic to
          //1. Redirect to login page or
          //2. Request refresh token
        }
        return Promise.reject(error);
      }
    );

    let config: RawAxiosRequestConfig = {};

    if (typeof callbackProgress !== 'undefined') {
      config = {
        headers: objHeader,
      };
    } else {
      config = {
        headers: objHeader,
      };
    }

    return axiosClient
      .post<T>(
        appConfig.api.url + apiCall,
        body,
        config
      )
      .then((response: AxiosResponse<T>) => {
        return response.data as T;
      })
      .catch((error) => {
        //console.error('api call error: ', error, error.message, apiCall, accessToken);
        return undefined as T;
      });
  }

  protected async queryApiL<T>(endpoint: string) {
    
    const state = store.getState();

    const apiToken = state.system.appConfig.apiKey;
    const apiUrl = state.system.appConfig.apiUrl;

    let objHeader = this.getRequestHeader();

    objHeader = {
      ...objHeader,
      'HeadersDefaults': 'common, delete, get, head',
      'Auth-Key' : apiToken
    };

    const config: RawAxiosRequestConfig = {
      headers: objHeader,
    };

    const axiosClient = axios.create({
      baseURL: apiUrl,
      timeout: 19000,
      withCredentials: true,
      headers: objHeader
    });

    return axiosClient
      .get<T>(
        appConfig.api.url + endpoint,
        config
      )
      .then((response: AxiosResponse<T>) => {
        return response.data as T;
      })
      .catch((error) => {
        //console.error('api call error: ', error, error.message, apiCall, accessToken);
        return undefined as T;
      });

  }

  protected getRequestHeader(): apiCallHeader {
    return {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
      'Access-Control-Allow-Headers': '*',
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };
  }
}

export { abstractApiCaller };
